export enum FieldSelectionMethod {
  FIELD_ID = "fieldId",
  FULL_FIELD_PATH = "fullFieldPath",
}
